<template>
  <div class="table-responsive">
    <table class="table-container table">
      <thead>
        <tr>
          <th class="checkbox" v-if="selectable">
            <label>
              <input type="checkbox" :checked="allSelected" @change="toggleSelectAll" />

              <span></span>
            </label>
          </th>
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    allItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    allSelected() {
      return this.selectedItems.length > 0 && this.selectedItems.length === this.allItems.length
    },
  },
  methods: {
    toggleSelectAll(event) {
      const isChecked = event.target.checked
      this.$emit("select-all", isChecked)
    },
    toggleRowSelection(item) {
      this.$emit("toggle-selection", item)
    },
    isSelected(item) {
      return this.selectedItems.includes(item)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  margin: 0;

  tr {
    border: 0;
  }

  th,
  td {
    text-align: left !important;
    padding: 0.625rem 0.5rem;
    font-size: 0.875rem;
    line-height: 19.1px;
    color: #202224;
    text-transform: none;

    &:first-child {
      padding-left: 1.25rem;
    }

    &:last-child {
      padding-right: 1.25rem;
    }
  }

  thead {
    tr {
      border-radius: 14px 14px 0 0;
      background: #F0F0F0;

      th {
        font-weight: 700;

        &:first-child {
          border-radius: 14px 0 0 0;
        }

        &:last-child {
          border-radius: 0 14px 0 0;
        }
      }

      .checkbox {
        label {
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 0.875rem;
          font-weight: 600;
          line-height: 19.1px;
          color: #606264;
          cursor: pointer;

          input[type="checkbox"] {
            display: none;
          }

          span {
            position: relative;
            display: inline-block;
            width: 1rem;
            height: 1rem;
            border: 2px solid #DFDCDC;
            border-radius: 2px;
            background-color: #FAFAFA;
            transition: background-color 0.2s, border-color 0.2s;
          }

          input[type="checkbox"]:checked+span {
            background-color: #1C2D5A;
          }

          input[type="checkbox"]:checked+span::after {
            content: '✓';
            color: white;
            font-size: 8px;
            position: absolute;
            top: 55%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #F0F0F0;

      td {
        font-weight: 500;
      }
    }
  }
}
</style>